import { createContext } from "react";
import { AttachmentsIndexContextValue } from "./types";

export const AttachmentsIndexContext = createContext<
  AttachmentsIndexContextValue | undefined
>(undefined);
